import { createKeySelector } from 'state/common/selectorFactories';

import { EMPTY_OBJECT, NavLayoutFlags } from 'config/constants';

import { State } from 'types/rootState';

const getNavLayout = (state: State) => state.navLayout || EMPTY_OBJECT;
const getLayoutFlags = createKeySelector(getNavLayout, 'layoutFlags', {});
export const isSidebarVisible = createKeySelector(getLayoutFlags, NavLayoutFlags.SIDEBAR_VISIBLE, false);
